import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricAvgposCountKayak extends MetricBase {
    constructor() {
        super({
            field: "metric_avgpos_count",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.kayak.avgposCount.chartName"),
            serieLabel: i18n.t("metrics.kayak.avgposCount.serieLabel"),
            tooltip: i18n.t("metrics.kayak.avgposCount.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricAvgposCountKayak;
